<div *ngIf="!policyScreen">
    <app-error-modal *ngIf="notTry" [buttonLeft]="" [buttonRight]="textButtonRight" [title]="errorTitle"
        [subtitle]="errorSubtitle" [iconType]="'error'" [isCloseable]="false" (outputValue)="resendOtp()">
    </app-error-modal>
    <div class="otp">
        <div class="row valid" id="validation-otp"></div>
        <ng-container>
            <div class="info-auth">
                <img loading="lazy" bc-img-fluid [src]="titleImageSrc" alt="">
                <p class="info-title">{{titleText}}</p>
                <p class="info-body" [innerHTML]="subTitle"></p>
            </div>

            <div>
                <form [formGroup]="formValidateOtp" autocomplete="off" class="form-validate-otp">
                    <div class="code-time-up">
                        <app-clock-down [restartCount]="restartCount" [totalTime]="totalTime" (resetCount)="this.notTry = true;"></app-clock-down>
                    </div>
            
                    <div class="enter-code">
                        <bc-icon name="lock" class="info-icon"></bc-icon>
                        <p>Ingresa el código</p>
                        <bc-input-token [id]="'txt-otp-number'" formControlName="otpCode"
                            num-inputs="6" 
                            info-message="Intento {{currentTry}}/{{maxTry}}"
                            error-message="Intento {{currentTry}}/{{maxTry}}"
                            (validated)="validateOtpForm($event)">
                        </bc-input-token>
                    </div>
                    <div class="submit-code">
                        <button bc-button sizeButton="small" id="submit-code"
                        (click)="submitOtp()"
                        [disabled]="form.otpCode.errors">
                            {{textButton}}
                        </button>
                        <p class="receiveNewCode" id="resendCode" (click)="resendOtp()">Recibir un nuevo código</p>
                    </div>
                </form>
            </div>

        </ng-container>
    </div>
</div>
<div *ngIf="policyScreen">
    <app-policy-finish 
        [success]="!errorScreen"
        [textModal]="textModal"
        [titleModal]="titleModal"
        [exitMessage]="exitMsg"
        [auth]="auth"
        (retryEmit)="retryLastCall()"
    ></app-policy-finish>
</div>
